import VaMediaObjectFileInput from "@/components/custom/VaMediaObjectFileInput.vue";
import VaImageDragAndDropInput from "@/components/custom/VaImageDragAndDropInput.vue";
import VaTinymceInput from "@/components/custom/VaTinymceInput.vue";
import "@/styles/styles.scss";
import SentryRRWeb from "@sentry/rrweb";
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import { abilitiesPlugin } from "@casl/vue";
import abilities from "./ability";
import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import admin from "./plugins/admin";
import { dripPlugin } from "./plugins/drip";
import { gtmPlugin } from "./plugins/gtm";
import "./plugins/chartist";
import "./plugins/i18n";
import "./plugins/vue-composition-api";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import { init } from "@/utility/authTokenRefresh";

// Initialize the token refresh interval
init();

Vue.config.productionTip = false;

const buildVersion = process.env.VUE_APP_VERSION || "No Version Variable Set";
const buildDisplay = process.env.VUE_APP_DISPLAY_ENV || "No Display Variable Set";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: buildDisplay,
    release: buildVersion,
    integrations: [
      new SentryRRWeb(),
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: 0.1,
  });
}
Vue.use(abilitiesPlugin, abilities());
Vue.use(dripPlugin);
Vue.use(gtmPlugin);

if (window.frameElement) {
  const root = document.querySelector(":root");
  root.style.setProperty("--v-background-base", "#FFFFFF");
}

new Vue({
  router,
  store,
  i18n,
  vuetify,
  admin,
  render: h => h(App),
}).$mount("#app");

Vue.component("VaTinymceInput", VaTinymceInput);
Vue.component("VaMediaObjectFileInput", VaMediaObjectFileInput);
Vue.component("VaImageDragAndDropInput", VaImageDragAndDropInput);
